module.exports = __webpack_public_path__ + "static/media/uni.ecbf16be.svg";